import { activateLocaleMessages } from "../effects.js";
import { SOURCE_LOCALE_ID } from "@bitcart/core/i18n";
import { useClientLocaleId } from "@bitcart/hooks";
import { useEffect } from "react";
import { usePageContext } from "vike-react/usePageContext";
import { navigate } from "vike/client/router";
//#region src/i18n/hooks/setup.ts
/**
* Configures localization application-wide.
*
* **Must be called exactly once in the app's root component!**
*/
const useI18nInitialization = ({ supportedLocaleIds }) => {
	const { localeId: pageLocaleId, urlLogical, messages } = usePageContext();
	const { clientLocaleId } = useClientLocaleId({ supportedLocaleIds });
	activateLocaleMessages(pageLocaleId, messages);
	useEffect(() => {
		if (pageLocaleId === SOURCE_LOCALE_ID && clientLocaleId !== SOURCE_LOCALE_ID) navigate(`/${clientLocaleId}` + (urlLogical === "/" ? "" : urlLogical), {
			keepScrollPosition: true,
			overwriteLastHistoryEntry: true
		});
	}, [
		clientLocaleId,
		pageLocaleId,
		urlLogical
	]);
};
//#endregion
export { useI18nInitialization };

//# sourceMappingURL=setup.js.map